// @flow

import { Component, type Node } from 'react';
import PropTypes from 'prop-types';

type Props = {|
  children: Node,
  context: *,
|};

/**
 * Exposes user agent information, as provided via the django context
 */
export default class DenzelUserAgent extends Component<Props> {
  getChildContext() {
    const { user = {} } = this.props.context;
    return {
      cookies: this.props.context.cookies,
      country: this.props.context.country,
      deepLink: this.props.context.deep_link,
      fullPath: this.props.context.full_path,
      isAuthenticated: this.props.context.is_authenticated,
      isFBBrowser: this.isFBBrowser(),
      isManagedAdvertiser: this.props.context.is_managed_advertiser,
      loginState: user.login_state,
      unauthId: this.props.context.unauth_id,
      userAgent: {
        browserName: this.props.context.browser_name,
        platform: this.props.context.user_agent_platform,
        platformVersion: this.props.context.user_agent_platform_version,
        isTablet: this.props.context.is_tablet_agent,
        isMobile: this.props.context.is_mobile_agent,
        isRetina: this.props.context.is_retina,
        canUseNativeApp: this.props.context.user_agent_can_use_native_app,
        raw: this.props.context.user_agent,
        // derived values
        isAndroid: this.props.context.user_agent_platform === 'android',
      },
    };
  }

  isFBBrowser() {
    const { context } = this.props;
    return context.user_agent.indexOf('FBAN') > -1 || context.user_agent.indexOf('FBAV') > -1;
  }

  render() {
    return this.props.children;
  }
}

DenzelUserAgent.childContextTypes = {
  cookies: PropTypes.object.isRequired,
  country: PropTypes.string,
  deepLink: PropTypes.string,
  fullPath: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isFBBrowser: PropTypes.bool.isRequired,
  isManagedAdvertiser: PropTypes.bool,
  loginState: PropTypes.number,
  unauthId: PropTypes.string.isRequired,
  userAgent: PropTypes.shape({
    browserName: PropTypes.string.isRequired,
    platform: PropTypes.string.isRequired,
    platformVersion: PropTypes.arrayOf(PropTypes.number),
    isTablet: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isRetina: PropTypes.bool.isRequired,
    canUseNativeApp: PropTypes.bool.isRequired,
    isAndroid: PropTypes.bool.isRequired,
    raw: PropTypes.string.isRequired,
  }).isRequired,
};

DenzelUserAgent.propTypes = {
  children: PropTypes.node.isRequired,
  context: PropTypes.shape({
    browser_name: PropTypes.string.isRequired,
    cookies: PropTypes.object.isRequired,
    country: PropTypes.string,
    deep_link: PropTypes.string,
    full_path: PropTypes.string.isRequired,
    user_agent_platform: PropTypes.string.isRequired,
    user_agent_platform_version: PropTypes.arrayOf(PropTypes.number),
    is_authenticated: PropTypes.bool.isRequired,
    is_tablet_agent: PropTypes.bool.isRequired,
    is_mobile_agent: PropTypes.bool.isRequired,
    is_retina: PropTypes.bool.isRequired,
    is_managed_advertiser: PropTypes.bool,
    user: PropTypes.shape({
      login_state: PropTypes.number,
    }),
    unauth_id: PropTypes.string.isRequired,
    user_agent: PropTypes.string.isRequired,
    user_agent_can_use_native_app: PropTypes.bool.isRequired,
  }).isRequired,
};
